"use strict";

var _slicedToArray = require("/Users/jere/Code/whitelist-standalone/node_modules/@babel/runtime/helpers/slicedToArray");

var _regeneratorRuntime = require("/Users/jere/Code/whitelist-standalone/node_modules/@babel/runtime/regenerator");

var _this = this;

var __awaiter = this && this.__awaiter || function (thisArg, _arguments, P, generator) {
  return new (P || (P = Promise))(function (resolve, reject) {
    function fulfilled(value) {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    }

    function rejected(value) {
      try {
        step(generator["throw"](value));
      } catch (e) {
        reject(e);
      }
    }

    function step(result) {
      result.done ? resolve(result.value) : new P(function (resolve) {
        resolve(result.value);
      }).then(fulfilled, rejected);
    }

    step((generator = generator.apply(thisArg, _arguments || [])).next());
  });
};

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var json_stable_stringify_1 = __importDefault(require("json-stable-stringify"));

var ethereum_address_1 = require("ethereum-address");

var types_1 = require("../types");

var PolymathError_1 = require("../PolymathError");
/**
 * Promisified version of a timeout
 *
 * @param amount - time to wait
 */


exports.delay = function (amount) {
  return __awaiter(_this, void 0, void 0,
  /*#__PURE__*/
  _regeneratorRuntime.mark(function _callee() {
    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            return _context.abrupt("return", new Promise(function (resolve) {
              setTimeout(function () {
                resolve();
              }, amount);
            }));

          case 1:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  }));
};
/**
 * Check if two addresses correspond to the same wallet
 */


function areSameAddress(a, b) {
  return a.toUpperCase() === b.toUpperCase();
}

exports.areSameAddress = areSameAddress;
/**
 * Check the length of a given string to ensure it meets correct bounds
 *
 * @param value - the string itself
 * @param variableName - the name of the variable associated to the string itself
 * @param opts - optional min and max length of the string. Defaults to a minimum of 0 (empty string) and a maximum of 32 characters
 */

function checkStringLength(value, variableName) {
  var opts = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {
    maxLength: 32
  };
  var _opts$minLength = opts.minLength,
      minLength = _opts$minLength === void 0 ? 0 : _opts$minLength,
      maxLength = opts.maxLength;

  if (value.length < minLength || value.length > maxLength) {
    throw new PolymathError_1.PolymathError({
      code: types_1.ErrorCode.ProcedureValidationError,
      message: "You must provide a valid ".concat(variableName, " ").concat(opts.minLength !== undefined ? "between ".concat(minLength, " and ").concat(maxLength) : "up to ".concat(maxLength), " characters long")
    });
  }
}

exports.checkStringLength = checkStringLength;
/**
 * @hidden
 * Generate a hash of an Entity's unique identifiers
 */

function serialize(entityType, uniqueIdentifiers) {
  return Buffer.from("".concat(entityType, ":").concat(json_stable_stringify_1.default(uniqueIdentifiers))).toString('base64');
}

exports.serialize = serialize;
/**
 * @hidden
 * Retrieve an Entity's unique identifiers from their hashed version
 */

function unserialize(id) {
  var unserialized = Buffer.from(id, 'base64').toString('utf8');
  var matched = unserialized.match(/^.*?:(.*)/);
  var errorMsg = 'Wrong ID format';

  if (!matched) {
    throw new Error(errorMsg);
  }

  var _matched = _slicedToArray(matched, 2),
      jsonString = _matched[1];

  try {
    return JSON.parse(jsonString);
  } catch (err) {
    throw new Error(errorMsg);
  }
}

exports.unserialize = unserialize;
/**
 * @hidden
 * Check if a string is a valid Ethereum address
 */

function isValidAddress(address) {
  return ethereum_address_1.isAddress(address);
}

exports.isValidAddress = isValidAddress;
/**
 * @hidden
 * Find all occurrences of a certain event in an array
 */

exports.findEvents = function (_ref) {
  var logs = _ref.logs,
      eventName = _ref.eventName;
  var foundLogs = logs.filter(function (log) {
    var l = log;
    return l.event === eventName;
  });
  return foundLogs;
};
/**
 * Convert a version number array into a string of type [[Version]]
 */


function convertVersionToEnum(versionBigNumber) {
  var version = versionBigNumber.map(function (num) {
    return num.toString();
  }).join('.');

  switch (version) {
    case types_1.Version.V3_0_0:
      {
        return types_1.Version.V3_0_0;
      }

    case types_1.Version.V3_1_0:
      {
        return types_1.Version.V3_1_0;
      }

    default:
      {
        throw new PolymathError_1.PolymathError({
          code: types_1.ErrorCode.FatalError,
          message: "Unsupported Security Token version. Expected 3.0.0 or 3.1.0, got ".concat(version)
        });
      }
  }
}

exports.convertVersionToEnum = convertVersionToEnum;